import { Mail, Phone, MapPin } from "lucide-react";
import { SiWhatsapp } from "@/components/site/Brands";
import Seo, { crumbsLd, orgLd } from "@/components/site/Seo";
import { PageHero } from "@/components/site/Blocks";
import LeadForm from "@/components/site/LeadForm";
import { EMAIL, PHONE, PHONE_TEL, waLink } from "@/data/site";
import { usePublicSettings } from "@/lib/publicSettings";

const WA = [["preventivo", "Preventivi"], ["siti", "Siti web"], ["crm", "CRM"], ["social", "Social"], ["consulenza", "Consulenze"]];

export default function Contact() {
  const { sedi } = usePublicSettings();
  const crumbs = [{ label: "Home", to: "/" }, { label: "Contatti", to: "/contatti" }];
  return (
    <>
      <Seo path="/contatti" title="Contatti — email, WhatsApp e sedi | STUDIO WEB NS"
        description="Contatta STUDIO WEB NS: info@studiowebns.it, WhatsApp +39 344 482 1886. Sedi a Milano, Como e Monza su appuntamento, clienti in tutta Italia." jsonLd={[crumbsLd(crumbs), orgLd]} />
      <PageHero crumbs={crumbs} eyebrow="Contatti" title="Scrivici. Ti rispondiamo entro un giorno lavorativo." intro="Il modo più veloce è WhatsApp o il modulo qui sotto. Le sedi ricevono su appuntamento." />
      <section className="py-14 md:py-20">
        <div className="wrap grid gap-14 lg:grid-cols-[1fr_1.2fr]">
          <div className="space-y-8">
            <div className="space-y-3">
              <a href={`mailto:${EMAIL}`} data-testid="contact-email" className="card flex items-center gap-4 p-5 hover:border-slate-900"><Mail className="h-5 w-5 text-blue-600" /><span className="font-medium">{EMAIL}</span></a>
              <a href={`tel:${PHONE_TEL}`} data-testid="contact-phone" className="card flex items-center gap-4 p-5 hover:border-slate-900"><Phone className="h-5 w-5 text-blue-600" /><span className="font-medium">{PHONE}</span></a>
            </div>
            <div>
              <p className="text-sm font-semibold text-slate-900">WhatsApp, con messaggio già pronto</p>
              <div className="mt-3 flex flex-wrap gap-2">
                {WA.map(([k, l]) => (
                  <a key={k} href={waLink(k)} target="_blank" rel="noopener noreferrer" data-testid={`contact-wa-${k}`} className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 px-4 py-2 text-sm font-medium hover:border-[#25D366] hover:text-[#128C7E]">
                    <SiWhatsapp className="h-4 w-4 text-[#25D366]" />{l}
                  </a>
                ))}
              </div>
            </div>
            <div className="space-y-4">
              {sedi.map((s) => (
                <div key={s.city} className="flex gap-4 border-t border-slate-100 pt-4">
                  <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-blue-600" />
                  <div>
                    <p className="font-display font-bold">{s.city}</p>
                    <p className="text-sm text-slate-600">{s.address}</p>
                    <p className="mt-1 text-xs text-slate-600">{[s.operative ? "Sede operativa" : "Sede non operativa", s.by_appointment && "su appuntamento", s.services].filter(Boolean).join(" · ")}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="card p-6 sm:p-10">
            <h2 className="text-2xl font-bold">Invia un messaggio</h2>
            <div className="mt-6"><LeadForm formType="contatto" full /></div>
          </div>
        </div>
      </section>
    </>
  );
}
